// These are tightly coupled with API client,
// But in a separate file to avoid Jest mock overrides

export const isPublicLogin = (response) => {
  return response && response.status === 401 && response.data.method === 'public-sso';
};

export const isSessionTerminated = (response) => {
  return response && response.status === 401 && response.data.sessionTerminated;
};

export const isUnauthorized = (response) => {
  return response && response.status === 403;
};
